import Icon from '@/components/ui/AppIcon';

export default function ProcessSection() {
  const steps = [
    {
      id: 'process_1',
      number: '01',
      title: 'CONSULTA INICIAL',
      description: 'Evaluamos tu vehículo y necesidades específicas',
      duration: '30 min',
      icon: 'ChatBubbleLeftRightIcon',
    },
    {
      id: 'process_2',
      number: '02',
      title: 'PREPARACIÓN',
      description: 'Lavado profundo y descontaminación de superficies',
      duration: '2-3 horas',
      icon: 'SparklesIcon',
    },
    {
      id: 'process_3',
      number: '03',
      title: 'INSTALACIÓN',
      description: 'Aplicación profesional con precisión milimétrica',
      duration: '4-8 horas',
      icon: 'WrenchScrewdriverIcon',
    },
    {
      id: 'process_4',
      number: '04',
      title: 'CURADO',
      description: 'Tiempo de secado y activación del producto',
      duration: '24 horas',
      icon: 'ClockIcon',
    },
    {
      id: 'process_5',
      number: '05',
      title: 'INSPECCIÓN',
      description: 'Control de calidad y ajustes finales',
      duration: '1 hora',
      icon: 'MagnifyingGlassIcon',
    },
    {
      id: 'process_6',
      number: '06',
      title: 'ENTREGA',
      description: 'Instrucciones de cuidado y garantía',
      duration: '30 min',
      icon: 'CheckBadgeIcon',
    },
  ];

  return (
    <section className="py-32 px-6 lg:px-12 bg-black">
      <div className="max-w-[1600px] mx-auto">
        {/* Section Header */}
        <div className="text-center mb-20">
          <span className="text-primary font-heading text-sm tracking-[0.3em] mb-4 block">
            NUESTRO PROCESO
          </span>
          <h2 className="font-heading text-4xl md:text-6xl text-white mb-6 tracking-tight">
            PROCESO DE
            <br />
            <span className="text-gradient-red">INSTALACIÓN</span>
          </h2>
          <p className="text-white/70 text-lg md:text-xl max-w-3xl mx-auto leading-relaxed">
            Cada paso está diseñado para garantizar resultados perfectos
          </p>
        </div>

        {/* Timeline */}
        <div className="relative">
          {/* Vertical Line */}
          <div className="absolute left-8 md:left-1/2 top-0 bottom-0 w-px bg-gradient-to-b from-primary via-primary/50 to-transparent hidden md:block" />

          {/* Steps */}
          <div className="space-y-16">
            {steps.map((step, index) => (
              <div
                key={step.id}
                className={`flex flex-col md:flex-row items-start gap-8 ${
                  index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                }`}
              >
                {/* Content */}
                <div className={`flex-1 ${index % 2 === 0 ? 'md:text-right' : 'md:text-left'}`}>
                  <div className="glass-card p-8 rounded-[32px] hover:bg-white/10 transition-all duration-300 inline-block">
                    <div className="flex items-center gap-4 mb-4">
                      <div className="w-12 h-12 rounded-full bg-primary/10 border border-primary/30 flex items-center justify-center">
                        <Icon
                          name={step.icon as any}
                          size={24}
                          variant="outline"
                          className="text-primary"
                        />
                      </div>
                      <div className="text-primary font-mono text-xs tracking-wider">
                        {step.duration}
                      </div>
                    </div>
                    <h3 className="font-heading text-xl text-white mb-3 tracking-wider">
                      {step.title}
                    </h3>
                    <p className="text-white/70 text-sm leading-relaxed max-w-md">
                      {step.description}
                    </p>
                  </div>
                </div>

                {/* Number Badge */}
                <div className="relative flex items-center justify-center flex-shrink-0">
                  <div className="w-16 h-16 rounded-full bg-primary border-4 border-black flex items-center justify-center z-10">
                    <span className="text-white font-heading text-xl">
                      {step.number}
                    </span>
                  </div>
                </div>

                {/* Spacer */}
                <div className="flex-1 hidden md:block" />
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-20">
          <div className="glass-card inline-block px-12 py-6 rounded-[32px]">
            <div className="text-white/60 text-sm mb-2">Tiempo total aproximado</div>
            <div className="text-white font-heading text-4xl mb-2">2-3 días</div>
            <div className="text-white/60 text-xs">Dependiendo del servicio</div>
          </div>
        </div>
      </div>
    </section>
  );
}